import { axiosObject } from "../config";

export interface CityMatch {
  uuid: string;
  name: string;
  slug: string;
}

export interface ResolvedPincodeData {
  state_uuid: string | null;
  state_name: string;
  state_slug: string | null;
  city_uuid: string | null;
  city_name: string;
  city_slug: string | null;
  city_matches: CityMatch[];
}

export interface PincodeData {
  code: string;
  city: string;
  district: string;
  state_name: string;
  country_ansi_code: string;
  resolved?: ResolvedPincodeData;
}

/**
 * Get pincode details from internal API
 * Returns city, district, state based on pincode.
 * When ENABLE_PINCODE_BASED_FETCHING is on, also returns a `resolved` object
 * with UUID and slug resolution for state and city.
 */
export function getPincodeDetails(pincode: string): Promise<PincodeData> {
  return new Promise((resolve, reject) => {
    const uri = `/auction/pincodes/${pincode}`;

    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
